var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutOfBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14H4V5H2V20H4V17H20V20H22V14H20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11H20C21.1046 11 22 11.8954 22 13V13H10V11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12C5 11.4477 5.44772 11 6 11H8C8.55228 11 9 11.4477 9 12V13H5V12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.50586L22.5297 6.03682L23.0609 5.5069L22.5307 4.97594L22 5.50586ZM15.25 5.5V4.75C14.8358 4.75 14.5 5.08579 14.5 5.5H15.25ZM17.9688 2.52992L21.4693 6.03578L22.5307 4.97594L19.0302 1.47008L17.9688 2.52992ZM21.4703 4.9749L17.9698 8.46709L19.0292 9.52901L22.5297 6.03682L21.4703 4.9749ZM21.25 4.75H15.25V6.25H21.25V4.75ZM14.5 5.5V8.99316H16V5.5H14.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfBed);
export default __webpack_public_path__ + "static/media/Out_of_bed.50095fed5cc28a3f84c48a68472b59e8.svg";
export { ForwardRef as ReactComponent };